import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import AdViewFrame from './AdViewFrame';
import AdViewToolbar from './AdViewToolbar/AdViewToolbar';

const Container = styled.div`
  display: grid;
  grid-template-rows: 50px 1fr;
  height: 100%;
`;

function AdView() {
  const store_creative = store.creative;
  if (!store_creative) return null;
  const store_ui = store.ui;

  return (
    <Container>
      <AdViewToolbar disabled={!store_creative.mounted} />
      <AdViewFrame
        creative={store_creative}
        fileDragging={store_ui.fileDragging}
      />
    </Container>
  );
}

export default observer(AdView);
